import { renderNavSearch } from "rs-search-ui";

const {
  searchKey,
  engineName,
  searchAction,
  endpointBase,
  placeholder,
  buttonAppearance,
  buttonText,
  iconOnly,
  iconPosition,
  elasticQuery,
  elasticAutocompleteQuery,
} = window.SEARCH_BOX_CONTENT;

const searchQuery = elasticQuery || {
  result_fields: {
    title: {
      snippet: {
        fallback: true,
      },
      raw: {},
    },
  },
};

const autocompleteQuery = elasticAutocompleteQuery || {
  results: {
    result_fields: {
      title: { snippet: { size: 100, fallback: true }, raw: {} },
      url: { raw: {} },
    },
  },
  suggestions: {
    size: 5,
    types: {
      documents: {
        title: { raw: {} },
      },
    },
  },
};

const navElement = document.getElementById("nav_search_box");
renderNavSearch(
  navElement,
  searchKey,
  engineName,
  endpointBase,
  searchQuery,
  autocompleteQuery,
  placeholder,
  searchAction,
  buttonAppearance,
  "",
  buttonText,
  iconOnly,
  iconPosition,
);
